import config from "environment";
import { getRequest, postRequest } from "./client";
import {
  CreateCustomPropertyContract,
  CreateEmployeeRecordContract,
  CustomProperty,
  EmployeeRecord,
  UpdateCustomPropertyContract,
  UpdateCustomPropertySettingsContract,
  UpdateEmployeeRecordContract
} from "winslow-core";

const { baseApi } = config;

export async function apiGetEmployeeRecordsForWorkspace(workspaceId: string): 
Promise<EmployeeRecord[] | null> {
  const fetchURL = `${baseApi}/employee-records/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetEmployeeRecordsForWorkspace");
}

export async function apiGetEmployeeRecord(id: string): 
Promise<EmployeeRecord | null> {
  const fetchURL = `${baseApi}/employee-records/employee/${id}`;
  return await getRequest(fetchURL, "API/apiGetEmployeeRecord");
}


// export async function apiGetPropertiesForWorkspace(workspaceId: string): 
// Promise<PropertyDefinition[] | null> {
//   const fetchURL = `${baseApi}/employee-records/properties/workspace/${workspaceId}`;
//   return await getRequest(fetchURL, "API/apiGetPropertiesForWorkspace");
// }

export async function apiGetCustomPropertiesForWorkspace(workspaceId: string): 
Promise<CustomProperty[] | null> {
  const fetchURL = `${baseApi}/employee-records/custom-properties/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetCustomPropertiesForWorkspace");
}

export async function apiGetCustomPropertyById(id: string): 
Promise<CustomProperty | null> {
  const fetchURL = `${baseApi}/employee-records/custom-property/${id}`;
  return await getRequest(fetchURL, "API/apiGetCustomPropertyById");
}

export async function apiCreateCustomProperty(
  payload: CreateCustomPropertyContract["Body"]
): Promise<CustomProperty | null> {
  const fetchURL = `${baseApi}/employee-records/custom-properties/create`;
  return await postRequest(fetchURL, payload, "API/apiCreateCustomProperty");
}

export async function apiUpdateCustomProperty(payload: UpdateCustomPropertyContract["Body"]):
Promise<CustomProperty | null> {
  const fetchURL = `${baseApi}/employee-records/custom-properties/update`;
  return await postRequest(fetchURL, payload, "API/apiUpdateCustomProperty");
}

export async function apiUpdateCustomPropertySettings(
  payload: UpdateCustomPropertySettingsContract["Body"]
): Promise<CustomProperty | null> {
  const fetchURL = `${baseApi}/employee-records/custom-properties/update-settings`;
  return await postRequest(fetchURL, payload, "API/apiUpdateCustomPropertySettings");
}

export async function apiCreateEmployeeRecord(
  payload: CreateEmployeeRecordContract["Body"]
): Promise<EmployeeRecord | null> {
  const fetchURL = `${baseApi}/employee-records/create`;
  return await postRequest(fetchURL, payload, "API/apiCreateEmployeeRecord");
}

export async function apiUpdateEmployeeRecord(
  payload: UpdateEmployeeRecordContract["Body"]
): Promise<EmployeeRecord | null> {
  const fetchURL = `${baseApi}/employee-records/update`;
  return await postRequest(fetchURL, payload, "API/apiUpdateEmployeeRecord");
}

export async function apiGetFlattenedEmployeeRecordsFromWorkspace(workspaceId: string): 
Promise<string | null> {
  const fetchURL = `${baseApi}/employee-records/flattened/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetFlattenedEmployeeRecordsFromWorkspace");
}